/**
 * Limit text to certain character length
 */
export function trimText(text: string, limit: number): string {
    return text.length > limit ? text.substr(0, limit) + '...' : text;
}
